import { useEffect, useState } from "react"
import { Grid, Button } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { obtenerLandingAllAction } from "./../../../ducks/landingDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import HeaderModal from "./../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import TablaLanding from "./Table"
import FormLanding from "./Form"

export const FPaquetesStyle = makeStyles((theme) => ({
    textField: {
        width: '90%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    textFieldMultiLinea: {
        width: '95%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    formControl: {
        width: "97%",
        margin: "5px"
    },
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    containerSpacingItem: {
        margin: "10px 10px"
    },
    modalBotonesCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalBotones: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    modalBoton: {
        margin: "15px 10px",
        width: "20%"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "1200px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))

const Landing = () => {
    const dispatch = useDispatch()
    const classes = FPaquetesStyle()
    const [open, setOpen] = useState(false)
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerLandingAllAction()).then(
            (Response) => {
                dispatch(offLoadAction())
            }
        );
    }, [dispatch])

    const ToggleModal = () => {
        setOpen(!open);
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={ToggleModal}>LandingPage</Button>
            <ModalBase
                classes={classes}
                open={open}
                onClose={ToggleModal}
            >
                <HeaderModal titulo={`Catalogo de landings`} handleClose={ToggleModal} />
                <Grid container className={classes.containerSpacing}>
                    <Grid xs={4}>
                        <FormLanding />
                    </Grid> 
                    <Grid xs={8}>
                        <TablaLanding />
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default Landing;
